import { isForeignCitizenship } from "./agreementDocumentsAccess";

/** Rodzaj potwierdzenia umowy papierowej: Dział Kadr albo strona operacyjna (rekruter). */
export type PaperConfirmationKind = "hr" | "recruiter";

interface PaperConfirmationEditInput {
  /** Czy użytkownik ma uprawnienie agreements_paper_confirm_hr / _recruiter */
  hasPermission: boolean;
  /** Nazwa obywatelstwa z zatwierdzonego kwestionariusza (non_draft) */
  citizenshipName?: string | null;
}

/**
 * Czy checkbox potwierdzenia umowy papierowej ma być w ogóle widoczny (ASMMNT-83).
 * Jedyne miejsce z warunkiem obywatelstwa po stronie frontu — włączenie dla Polaków
 * to zmiana tej jednej funkcji.
 */
export function isPaperConfirmationVisible(
  citizenshipName?: string | null,
): boolean {
  return isForeignCitizenship(citizenshipName);
}

/** Czy użytkownik może zaznaczyć/odznaczyć potwierdzenie (widoczne, ale nieaktywne bez uprawnienia). */
export function canEditPaperConfirmation({
  hasPermission,
  citizenshipName,
}: PaperConfirmationEditInput): boolean {
  return hasPermission && isPaperConfirmationVisible(citizenshipName);
}
